import React from 'react';
import Clients from '../components/Clients';
import Cta from '../components/Cta';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import Portfolio from '../components/Portfolio';
import Providers from '../components/Providers';
import Services from '../components/Offerings';
import HowWeWork from '../components/HowWeWork';


const Home = () => {
    return (
        <>
            <Hero />
            <Intro />
            <Services />
            <Providers />
            <HowWeWork />
            <Cta/>
            <Footer/>
        </>

    )
}

export default Home;

